import React, { memo, useRef } from 'react';
import { PlayerContainer, ScreenHeightLayout } from './VideoPlayerLayout.styles';
import { usePositionOnScreen } from '../../hooks/use-position-on-screen';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoPlayerLayout = /*#__PURE__*/memo(({
  size,
  isLoading,
  segmentsVisible,
  segmentViewHeight,
  isEmbedded,
  children
}) => {
  const layoutRef = useRef(null);
  const layoutPosition = usePositionOnScreen(layoutRef);
  return /*#__PURE__*/_jsx(ScreenHeightLayout, {
    ref: layoutRef,
    segmentsVisible: segmentsVisible,
    segmentViewHeight: segmentViewHeight,
    viewHeight: size.viewHeight,
    screenHeightHeader: size.screenHeightHeader,
    layoutPosition: layoutPosition,
    isEmbedded: isEmbedded,
    children: /*#__PURE__*/_jsx(PlayerContainer, {
      isLoading: isLoading,
      children: children
    })
  });
});